import React, { Component } from 'react';
import PropTypes from 'prop-types'

const mapStyles = [
  // { featureType: 'all', stylers: [{ saturation: 0 }] },
  { featureType: 'poi', stylers: [{ visibility: 'off' }] },
  { featureType: 'transit', stylers: [{ visibility: 'off' }] },
  // { featureType: 'road.highway', elementType: 'labels', stylers: [{ visibility: 'off' }] },
  // { featureType: 'road.arterial', elementType: 'labels', stylers: [{ visibility: 'off' }] },
  // { featureType: 'landscape', stylers: [{ visibility: 'off' }] },
  // { featureType: 'administrative.land_parcel', stylers: [{ visibility: 'off' }] },
  // { featureType: 'administrative.neighborhood', stylers: [{ visibility: 'off' }] },
];

class Map extends Component {
  static propTypes = {
    center: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number
    }).isRequired,
    markerPosition: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number
    }),
    onMarkerMove: PropTypes.func,
  }
  map = undefined;
  marker = undefined;

  componentDidMount() {
    const { center, markerPosition } = this.props;
    this.map = new window.google.maps.Map(this.refs.map, {
      center,
      zoom: 15,
      disableDefaultUI: true,
      styles: mapStyles,
    });
    this.map.addListener('click', this.props.onMarkerMove);
    this.marker = new window.google.maps.Marker({
      position: markerPosition || center,
      title: 'Hello World!',
      draggable: true,
      visible: markerPosition !== undefined,
    });
    this.marker.addListener('dragend', this.props.onMarkerMove);
    this.marker.setMap(this.map);
  }

  clearMarkers = () => {
    this.markers.forEach((marker) => {
      marker.setMap(null);
    })
    this.markers = [];
  }

  render() {
    if (this.map) {
      const { center, markerPosition } = this.props;
      this.map.setCenter(center);
      if (markerPosition) {
        this.marker.setVisible(true);
        this.marker.setPosition(markerPosition);
      }
    }
    return (
      <div ref="map" className="map"></div>
    )
  }
}

export default Map



// WEBPACK FOOTER //
// ./src/components/Map.js